import moment from "moment";
import { CONVERSATION_TYPE_OTHER, CONVERSATION_TYPES_ENUM } from "src/features/auth/config/conversations";
import getConfigEnumText from "../../../common/utils/config/configEnumText";
import i18n from "../../../app/services/i18n";
export const getConversationTitle = (callDetails) => callDetails.title
    || `${getConfigEnumText(CONVERSATION_TYPES_ENUM, callDetails.type)
        || CONVERSATION_TYPE_OTHER} ${i18n.t('conversation.on_')} ${callDetails.startedAt
        ? moment(callDetails.startedAt) : moment().startOf('hour')}`;
